var _defs, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaignoireMauvaisePosition2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baignoire",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 891 554.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-width:5px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:6px;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bagnoire mauvaise r\xE9ponse 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467,1283h576s179,11,179-303H336C336,1146,384,1283,467,1283Z",
    transform: "translate(-333.5 -769.9)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 437.5,
    y: 336.1,
    width: 297,
    height: 148
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mauvaise_2",
    "data-name": "mauvaise 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 581.84,
    cy: 164.45,
    r: 79.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M891,1195s-59.5-72.5-84-117l18-131c8-34,11-54-15-85,0,0-95-75-251-89-27.35-2.45-110,39-65,136l141.5,157.5L581,1283c-6,46,41,48,49,19l70-176,47-16,106,110C873,1240,907,1218,891,1195Zm-143.72-83.73L700,1126l16-46c5.55-20.52,6.78-38.21-1-50L635.5,914.5,734,947c10,4,13,20,13,26l-5,70C742,1063,740,1078,747.28,1111.27Z",
    transform: "translate(-333.5 -769.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M705,1121l-6,16,50-20c-1-3-4-3-6-11Z",
    transform: "translate(-333.5 -769.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaignoireMauvaisePosition2);
export default __webpack_public_path__ + "static/media/baignoire_mauvaise_position_2.d6251df6de5767607341613ebb656e99.svg";
export { ForwardRef as ReactComponent };